import {
  getToken,
  setToken,
  setDeviceId,
  removeToken,
  getChannel,
  getUserId,
  getCipherText,
  setUserId,
  setChannel,
  setCipherText,
  removeChannel,
  getUrlKey,
  getHeJiaInfo,
  setHeJiaInfo,
} from '@/utils/auth' // 验权
import router from './router'
import store from './store'
import {
  Toast,
  Dialog
} from 'vant'
import wx from 'weixin-js-sdk';
import ft from 'finclip-js-sdk'
import {
  getCurrentPenInfo
} from "@/api/pen";
import {
  appletLoginAuth
} from '@/api/extra';
import {
  getIndependentSystemList
} from "@/api/system";

var whiteList = ['/login', '/test', '/watch/*', '/fileView', '/sms/*'];
var isSms = getUrlKey("isSms");
if (isSms == 1) {
  whiteList = ['/login', '/smartLearn/paperLearn', '/watch/*', '/fileView', '/smartLearnOther/final', '/smartLearn/learnHistory', '/smartLearnOther/tips', '/smartLearnOther/openScreen', '/test', '/sms/login', '/sms/smsOpen','/sms/free']; // 不重定向白名单
} else {
  whiteList = ['/login', '/test', '/watch/*', '/fileView', '/sms/login', '/sms/smsOpen','/sms/free']; // 不重定向白名单
}


const regexWhiteList = whiteList.map(rule => new RegExp('^' + rule.replace('*', '.*') + '$'));

const whiteBindList = ['/active/share/*', '/shop/*', '/bindPhone', '/watch/*', '/reward/account/*', '/orderPackage/*', '/orderPackage/*', '/smartLearn/*', '/smartLearnOther/*'] //不需要绑定设备白名单
const regexWhiteBindList = whiteBindList.map(rule => new RegExp('^' + rule.replace('*', '.*') + '$'));

const whiteBindPhoneList = ['/bindPhone', '/watch/*', '*'] //不需要绑定手机号白名单
const regexWhiteBindPhoneList = whiteBindPhoneList.map(rule => new RegExp('^' + rule.replace('*', '.*') + '$'));

const whiteForceBindYunPanList = ['/bindPhone', '/home', '/bind', '/choiceFamily', '/waitBind', '/family', '/equipmentInfo', '/active/share/*', '/shop/*', '/watch/*', '/reward/account/*', '/orderPackage/*'] //不需要强制绑定网盘的页面
const regexWhiteForceBindYunPanList = whiteForceBindYunPanList.map(rule => new RegExp('^' + rule.replace('*', '.*') + '$'));


const whiteZhixueList = ['/smartLearnOther/learnIndex', '/smartLearnOther/openPay'] // 智学登录重定向名单

router.beforeEach((to, from, next) => {
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }

  console.log(to.path + "," + regexWhiteBindList.some(regex => regex.test(to.path)));
  if (to.path == '/homexiaoyi') {
    const currentURL = to.fullPath;
    console.log('fullPath:' + currentURL)
    // 使用正则表达式匹配 URL 中的查询参数部分
    const parameterMatch = currentURL.match(/\?(.*)/);
    var queryString = '';
    if (parameterMatch) {
      // 如果有匹配到参数部分
      queryString = parameterMatch[1].split("&")[0];

      // 将查询参数字符串解析为对象
      // const params = {};
      // queryString.split('&').forEach(pair => {
      //   const [key, value] = pair.split('=');
      //   params[key] = decodeURIComponent(value);
      // });
      // 使用 params 获取特定参数的值
      // const parameterValue = params.parameterName;
    }

    next({
      path: '/home',
      query: {
        channel: 'xiaoyi',
        cipherText: queryString,
      },
      replace: false
    })
    return;
  }



  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (window.__fcjs_environment === 'miniprogram') {
    if (to.meta.yunTitle) {
      document.title = to.meta.yunTitle
    }
  }
  //非PC页面，全部加入移动端meta
  // if (!to.meta.isPc) {
  //   let meta = document.createElement('meta');
  //   meta.content = 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no';
  //   meta.name = 'viewport';
  //   document.getElementsByTagName('head')[0].appendChild(meta);
  // }


  //移除meta
  // var metaArr = Array.from(document.getElementsByTagName('meta'));
  // var meta = metaArr.find(m => m.name == 'viewport');
  // meta.parentNode.removeChild(meta)

  // if(window.__fcjs_environment==='miniprogram'){
  //   alert("当前是云盘小程序")
  // }else if(window.__wxjs_environment==='miniprogram'){
  //   alert("当前是微信小程序")
  // }else{
  //   alert("当前是H5环境")
  // }

  var query = to.query;
  var sourceUrl = process.env.BASE_API + '#' + to.path;
  var param = '';
  for (var key in query) {
    if (key != 'sourceUrl') {
      param = param + key + '=' + query[key] + '&';
    }
  }
  sourceUrl = sourceUrl + '?' + param;




  //测试打开 start
  // store.dispatch('GetInfo').then(res => { // 拉取用户信息
  //   if (store.getters.isBindPhone == 0) {
  //     getIndependentSystemList().then(resSys => {
  //       var independentSystemList = resSys.data;
  //       console.log(independentSystemList.indexOf(store.getters.userChannelTag) == -1);
  //       if (independentSystemList.indexOf(store.getters.userChannelTag) == -1) {
  //         if (regexWhiteBindPhoneList.some(regex => regex.test(to.path))) {
  //           next()
  //         } else {
  //           next({
  //             path: '/bindPhone',
  //             query: {
  //               sourceUrl: sourceUrl
  //             },
  //             replace: true
  //           })
  //         }
  //       }
  //     })
  //   }
  //   if (to.path === '/bind' || to.path === '/waitBind' || to.path === '/smartLearnOther/guide') {
  //     next();
  //   } else {
  //     if (store.getters.roles.length === 0) {
  //       if (whiteZhixueList.indexOf(to.path) !== -1) {
  //         next('/smartLearnOther/guide')
  //       } else if (regexWhiteBindList.some(regex => regex.test(to.path)) ) {
  //         next();
  //       } else {
  //         next('/bind');
  //       }

  //     }
  //   }
  //   jumpByTag(to.path, next);
  //   jumpByEquipment(to.path, next)
  //   next();
  // }).catch((err) => {
  //   // store.dispatch('LogOut').then(() => {
  //   //   // Toast.fail(err || 'Verification failed, please login again');
  //   //   //放行，自动获取openid
  //   // })
  //   next();

  // })
  // return false;
  //测试打开 end

  /**由于移动云盘每次用户可能不一致，每次访问都使用传递来的token */
  const isMiniProgram = /miniProgram/i.test(navigator.userAgent.toLowerCase())
  // window.__fcjs_environment='miniprogram';
  if (window.__fcjs_environment === 'miniprogram') {
    // 获取url后token，token设置入全局变量token中。
    var token = to.query.token;
    if (token && token != getToken()) {
      removeToken();
    }
  }
  console.log(location.href);
  var channel = query.channel;
  var cipherText = query.cipherText;
  var needRemoveXiaoyiToken = false;
  var heJiaImei = ""
  var heJiaPhone = ""
  if ("xiaoyi" === channel) {
    setChannel(channel);
    if (
      getCipherText() != undefined &&
      getCipherText() != "undefined" &&
      getCipherText() != "" &&
      getCipherText() != cipherText
    ) {
      needRemoveXiaoyiToken = true;
    }
    setCipherText(cipherText);
  } else {
    /**获取并设置渠道标识 */
    channel = getUrlKey("channel");
    if("hejiaqin" == channel){
      heJiaImei = getUrlKey("imei")
      heJiaPhone = getUrlKey("phone")
    }
    if (channel && channel != getChannel()) {
      setChannel(channel);
    }
  }

  /**由于魔盘每次用户可能不一致，userId不一致时获取新用户信息 */
  if (getChannel() === 'mopan') {
    clplus.clPortal.getUserId(
      function (userId) {
        if (getToken() != undefined && getToken() != 'undefined' && heJiaPhone != getUserId()) {
          removeToken();
          const currentPath = to.path;
          var query = to.query;
          query['time'] = Math.random();
          next({
            path: currentPath,
            query: query,
          })
          return;
        }
      },
      function (error) {
        alert('userId' + error);
      }
    );
  }else if(getChannel() === "xiaoyi"){
    if (needRemoveXiaoyiToken) {
      removeToken();
      const currentPath = to.path;
      var query = to.query;
      query["time"] = Math.random();
      next({
        path: currentPath,
        query: query
      });
      return;
    }
  }else if(getChannel() === "hejiaqin"){
      if (getToken() != undefined && getToken() != 'undefined' && heJiaPhone != getUserId()) {
        removeToken();
        const currentPath = to.path;
        var query = to.query;
        query["time"] = Math.random();
        next({
          path: currentPath,
          query: query
        });
        return;
    }
  }

  console.log('当前渠道：', getChannel())

  if (getToken() != undefined && getToken() != 'undefined') {
    if (!store.getters.status) { //没有获取到用户信息
      store.dispatch('GetInfo').then(res => { // 拉取用户信息
        if (store.getters.isBindPhone == 0) {
          getIndependentSystemList().then(resSys => {
            var independentSystemList = resSys.data;
            if (independentSystemList.indexOf(store.getters.userChannelTag) == -1) {
              if (regexWhiteBindPhoneList.some(regex => regex.test(to.path))) {
                mainFunc(to, next);
                return;
              } else {
                next({
                  path: '/bindPhone',
                  query: {
                    sourceUrl: sourceUrl
                  },
                  replace: true
                })
                return;
              }
            } else {
              mainFunc(to, next);
            }
          })
        } else {
          mainFunc(to, next);
        }

      }).catch((err) => {
        store.dispatch('LogOut').then(() => {
          // Toast.fail(err || 'Verification failed, please login again');
          //放行，自动获取openid
          next();
          return;
        })
      })
    } else {
      if (to.path === '/bind' || to.path === '/waitBind' || to.path === '/choiceFamily') {
        next();
        return;
      } else {
        if (store.getters.roles.length === 0) {
          if (regexWhiteBindList.some(regex => regex.test(to.path))) {
            next();
            return;
          } else {
            next('/bind');
            return;
          }
        }
      }
      console.log(store.getters.roles.length)
      jumpByTag(to.path, next);
      jumpByEquipment(to.path, next);
      next();
      return;
    }
  } else {
    // if(to.query.code){
    //   setToken(to.query.code);
    //   location.reload();
    // }
    if (regexWhiteList.some(regex => regex.test(to.path))) {
      next({
        replace: true
      })
    } else {
      if (window.__fcjs_environment === 'miniprogram') {
        //todo 获取url后token，token设置入全局变量token中。
        var token = to.query.token;
        var deviceId = to.query.deviceId;
        store.dispatch('YunAppletLogin', {
          token: token,
          deviceId: deviceId
        }).then(res => {
          location.reload();
        })
      } else if (channel == 'mopan') {

        // store.dispatch('MoPanLogin', { phone: '17600449767', userId: '1671036468156854274' }).then(res => {
        //   const currentPath = to.path;
        //   var query = to.query;
        //   query['time'] = Math.random();
        //   next({
        //     path:currentPath,
        //     query:query,
        //   })
        //   // location.reload();
        // })
        clplus.clPortal.getUserId(
          function (userId) {
            clplus.clPortal.fetchPhone(
              function (phone) {
                store.dispatch('MoPanLogin', {
                  phone: phone,
                  userId: userId
                }).then(res => {
                  const currentPath = to.path;
                  var query = to.query;
                  query['time'] = Math.random();
                  next({
                    path: currentPath,
                    query: query,
                  })
                  // location.reload();
                })
              },
              function (error) {
                alert('手机号：' + error);
              }
            );
          },
          function (error) {
            alert('userId' + error);
          }
        );
      } else if (channel == "xiaoyi") {
        store
          .dispatch("XiaoYiLogin", {
            cipherText: getCipherText()
          })
          .then(res => {
            const currentPath = to.path;
            var query = to.query;
            query["time"] = Math.random();
            next({
              path: currentPath,
              query: query
            });
            console.log("刷新");
            // location.reload();
          });
      } else if (channel == "hejiaqin") {
        store
          .dispatch("HeJiaLogin", {
            imei:heJiaImei,
            phone:heJiaPhone
          })
          .then(res => {
            const currentPath = to.path;
            var query = to.query;
            query["time"] = Math.random();
            next({
              path: currentPath,
              query: query
            });
            console.log("刷新");
            // location.reload();
          });
      } else {
        // var query = to.query;
        // var sourceUrl = process.env.BASE_API + '#' + to.path;
        // var param = '';
        // for (var key in query) {
        //   if (key != 'sourceUrl') {
        //     param = param + key + '=' + query[key] + '&';
        //   }
        // }
        // sourceUrl = sourceUrl + '?' + param;
        next({
          path: '/login',
          query: {
            sourceUrl: sourceUrl
          },
          replace: true
        })
      }
    }
  }

})

function jumpByEquipment(path, next) {
  var model = store.getters.model;
  if (path === '/home') {
    switch (model) {
      case 'S10':
        next();
        break;
      case 'T10':
      case 'S3':
      case 'S15':
        next('/homeZhixue');
        break;
      default:
        next();
        break;
    }
  }
  if (path === '/homeZhixue') {
    switch (model) {
      case 'S10':
        next('/home');
        break;
      case 'T10':
      case 'S3':
      case 'S15':
        next();
        break;
      default:
        next('/home');
        break;
    }
  }
}

function jumpByTag(path, next) {

  var yunpanSwitch = store.getters.yunpanSwitch;
  var telecomYunpanSwitch = store.getters.telecomYunpanSwitch;
  var ltYunpanSwitch = store.getters.ltYunpanSwitch;

  if (regexWhiteForceBindYunPanList.some(regex => regex.test(path))) {
    next();
    return;
  }

  getCurrentPenInfo().then(res => {
    var penInfo = res.data;

    if (penInfo.isForceBindYunPan != 1) {
      return;
    }

    if (yunpanSwitch == 1) {
      var ydH5PanAccessToken = penInfo.ydH5PanAccessToken;
      if (!ydH5PanAccessToken) {
        //未绑定移动云盘
        if (store.getters.cpr.status === 1) {
          //仅管理员可以绑定
          next({
            path: '/bindYunPan',
            replace: true
          })
          return;
        } else {
          //普通用户限制进入
          next({
            path: '/bindYunPan',
            replace: true
          })
          return;
        }
      }
    }

    if (telecomYunpanSwitch == 1) {
      var telecomPanAccessToken = penInfo.telecomPanAccessToken;
      if (!telecomPanAccessToken) {
        //未绑定天翼云盘
        if (store.getters.cpr.status === 1) {
          //仅管理员可以绑定
          next({
            path: '/bindTelecomYunPan',
            replace: true
          })
          return false;
        } else {
          //普通用户限制进入
          next({
            path: '/bindTelecomYunPan',
            replace: true
          })
          return false;
        }
      }
    }

    if (ltYunpanSwitch == 1) {
      var ltPanStatus = penInfo.ltPanStatus;
      if (ltPanStatus && ltPanStatus === 1) { } else {
        // 未绑定联通网盘
        if (store.getters.cpr.status === 1) {
          //仅管理员可以绑定
          next({
            path: '/bindLtPan',
            replace: true
          })
          return false;
        } else {
          //普通用户限制进入
          next({
            path: '/bindLtPan',
            replace: true
          })
          return false;
        }
      }
    }


  }).catch(err => {
    console.log(err);
    Toast.fail("网络异常，请稍后再试")
    next(false);
  })
}



function mainFunc(to, next) {
  if (to.path === '/bind' || to.path === '/waitBind' || to.path === '/choiceFamily' || to.path === '/smartLearnOther/guide' || to.path == '/autoBind') {
    next();
    return false;
  } else {
    if (store.getters.roles.length === 0) {
      //移动云盘小程序-特殊
      if (window.__fcjs_environment === 'miniprogram') {
        if (regexWhiteBindList.some(regex => regex.test(to.path))) {
          next();
          return false;
        } else {
          Dialog.alert({
            message: '未绑定词典笔，请返回入口绑定',
            beforeClose: (action, done) => {
              done();
              ft.miniProgram.navigateBack({
                delta: 2
              });
            },
          });
        }
        return false;
      }
      if (whiteZhixueList.indexOf(to.path) !== -1) {
        next('/smartLearnOther/guide')
        return false;
      } else if (regexWhiteList.some(regex => regex.test(to.path))) {
        next();
        return false;
      } else if (regexWhiteBindList.some(regex => regex.test(to.path))) {
        next();
        return false;
      } else {
        next('/bind');
        return false;
      }
    }
  }
  console.log(store.getters.roles.length)
  jumpByTag(to.path, next);
  jumpByEquipment(to.path, next)
  next();
}

router.afterEach(() => { })




// WEBPACK FOOTER //
// ./src/permission.js